import React from "react";

export default function SectionHeading({
  eyebrow,
  title,
  lede,
  align = "left",
  className = "",
}) {
  const alignCls =
    align === "center" ? "text-center mx-auto" : align === "right" ? "text-right ml-auto" : "text-left";
  return (
    <div className={`${alignCls} max-w-3xl ${className}`}>
      {eyebrow && (
        <div className="nx-mono text-xs uppercase tracking-[0.32em] text-[#38D8FF] mb-4">
          / {eyebrow}
        </div>
      )}
      <h2 className="nx-heading text-3xl sm:text-4xl lg:text-5xl font-bold leading-tight tracking-tight">
        {title}
      </h2>
      {lede && (
        <p className="mt-5 text-base sm:text-lg text-white/70 leading-relaxed">{lede}</p>
      )}
    </div>
  );
}
